import React, { useEffect, useState } from 'react'
import Footer from './Footer'
import Header from './Header'
import {
  Container,
  Row,
  Col,
  Tab,
  Nav,
  Card as Cards,
  Button,
  Table,
} from 'react-bootstrap'
import { BreadcrumbBox } from './common/Breadcrumb'
// import { Styles } from "../styles/homepage";
import { Styless } from './common/styles/FacultyOfAgriculture'
import { Link, useLocation } from 'react-router-dom'
import SearchResearcher from './SearchResearcher'
import AdmissionFormSidebar from './AdmissionFormSidebar'

const BASE_URI = 'https://api.shooliniuniversity.com'

const NotFound = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
    return () => {}
  }, [])

  useEffect(() => {
    document.title = `404 | Shoolini University`

    return () => {
      document.title = 'Shoolini University'
    }
  })

  return (
    <div className="main-wrapper course-details-page">
      {/* Header 2 */}
      <Header />

      {/* Breadcroumb */}
      <BreadcrumbBox title="Not Found" />
      <Styless>
        <section className="course-details-area our-webcoderskull text-center">
          <h1>Oops! 404</h1>
        </section>
      </Styless>

      {/* Footer 2 */}
      <Footer />
    </div>
  )
}

export default NotFound
